var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRing = function SvgRing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.319 11.059h5.326l4.487-6.801a1.13 1.13 0 0 0 0-1.248l-1.091-1.835a1.12 1.12 0 0 0-.39-.37 1.07 1.07 0 0 0-.51-.141H16.895a1.048 1.048 0 0 0-.512.137c-.157.09-.29.218-.388.374l-1.127 1.872a1.13 1.13 0 0 0 0 1.248l4.45 6.764Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 29.567,
    r: 14.815,
    stroke: "currentColor",
    strokeWidth: 1.445
  })));
};
export default SvgRing;